module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "noData-pic"
  }, [_c('p', {
    staticClass: "noData-text"
  }, [_vm._v(_vm._s(_vm.tips))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c4b266","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoRecord.vue
// module id = 776
// module chunks = 0